import { useSelector } from 'react-redux';

export function useIsSupplierAdmin() {
  const { roles: userRoles, supplierId } = useSelector((state) => state.role);
  const isSuperAdmin = userRoles?.is_super_admin;
  const isSupplierAdmin = userRoles?.suppliers.find((supplier) => supplier.id === supplierId)?.is_admin;
  return !!(isSuperAdmin || isSupplierAdmin);
}
